export default __webpack_public_path__ + "static/plum-ring-gold-3448a587af407e1f964058ee2c736034.png";